import { Center } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaAuthorisationBackground } from "../../auth/components/rana-authorisation-background";
import { Errors } from "../utils/get-errors";

import { RanaButton } from "./rana-button";
import { RanaErrors } from "./rana-errors";
import { RanaHeading } from "./rana-heading";

interface RanaInfo {
  title: string | JSX.Element;
  errors?: Errors;
  button?: {
    text: string | JSX.Element;
    onClick: () => void;
  };
}

export function RanaInfoBox({ title, errors, button }: RanaInfo) {
  const hasButton = !!button;
  return (
    <RanaAuthorisationBackground
      pageSubTitle={<FormattedMessage id="page_title.info" defaultMessage="Info" />}
    >
      <Center
        flexDirection="column"
        w="full"
        maxWidth="xl"
        background="brand.cloudy"
        padding={8}
        gap={8}
      >
        <RanaHeading type="h2" color={errors ? "semantic.error.main" : "inherit"}>
          {title}
        </RanaHeading>
        <RanaErrors errors={errors} />
        {hasButton && (
          <RanaButton w="full" variant="primary" onClick={button.onClick}>
            {button.text}
          </RanaButton>
        )}
      </Center>
    </RanaAuthorisationBackground>
  );
}
